import React, {useState} from 'react';

import {ChangeRequestReviewView} from 'src/modules/ai/change-request-review/change-request-review.view';
import {getChangeRequestReviewById} from 'src/openapi/apis/ChangeRequestReviewControllerApi';
import {useAppDispatch} from 'src/store';

type Props = {
    changeRequestId: number | null,
};

export const ChangeRequestReviewController = ({changeRequestId}: Props) => {
    const dispatch = useAppDispatch();
    const [inReview, setInReview] = useState(false);

    const onAiAssist = async () => {
        if (changeRequestId) {
            setInReview(true);

            await dispatch(getChangeRequestReviewById({changeRequestId}));

            setInReview(false);
        }
    };

    return (
        <ChangeRequestReviewView
            inReview={inReview}
            onAiAssist={onAiAssist}
        />
    );
};
